import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setMasterServicesFormAction } from "../../redux/rootReducer";
import { MASTER_SERVICES_FORM_INITIAL } from "../../redux/initialStateConstant";
import Checkbox from "../Checkbox/Checkbox";
import { UpdateMasterServicesThunk } from "../../redux/thunks/UpdateMasterServicesThunk";

const MasterServicesForm = () => {
    const dispatch = useDispatch();
    const services_settings = useSelector(state => state.services_settings);
    const master_services_form = useSelector(state => state.master_services_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setMasterServicesFormAction(MASTER_SERVICES_FORM_INITIAL));
                            } }
                        />
                        <div className="form__title">Список мастеров</div>
                    </div>
                    <div className="form__field">
                        {
                            services_settings.masters.map((elem) => (
                                <div key={ elem.id } style={{ marginBottom: 10 }}>
                                    <Checkbox
                                        active={ master_services_form.masters.includes(elem.id) }
                                        caption={ elem.name }
                                        handler={ () => {
                                            // Копируем список мастеров
                                            let masters_arr = [...master_services_form.masters];

                                            // Удаляем мастера если он найден
                                            if (masters_arr.includes(elem.id)) {
                                                masters_arr = masters_arr.filter(el => el !== elem.id);
                                            }
                                            else {
                                                masters_arr.push(elem.id);
                                            }

                                            dispatch(setMasterServicesFormAction({
                                                ...master_services_form,
                                                masters: masters_arr
                                            }));
                                        } }
                                    />
                                </div>
                            ))
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(UpdateMasterServicesThunk({
                                    service_id: master_services_form.service_id,
                                    masters: JSON.stringify(master_services_form.masters)
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MasterServicesForm;